<template>
   <div id="admin-map">
      <div class="base-layer-selector-wrapper">
         <base-layer-selector :get-map="getMap"/>
      </div>
   </div>
</template>

<script>
import BaseLayerSelector from '../../../../molecules/Home/BaseLayerSelector';
import Map from 'ol/Map';
import View from 'ol/View';
import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';
import { getControls } from '../../../../../js/map';
import BingMaps from 'ol/source/BingMaps';
import { makeLayer } from '../../../../../js/layers';

const adminLayerInfos = [
   {
      "id": "country",
      "title": "Country Boundary",
      "visible": true,
      "type": "WMS",
      "wms_params": {
            "url": "http://geoserver.pathway.com.np/geoserver/nepal/wms",
            "source_version": "1.1.1",
            "source_layers": "nepal:country",
            "source_styles": null,
            "layer": "country"
      }
   },
   {
      "id": "province",
      "title": "Province Boundary",
      "visible": true,
      "type": "WMS",
      "wms_params": {
            "url": "http://geoserver.pathway.com.np/geoserver/nepal/wms",
            "source_version": "1.1.1",
            "source_layers": "nepal:province",
            "source_styles": "mep_province",
            "layer": "province"
      }
   },
   {
      "id": "district",
      "title": "District Boundary",
      "visible": true,
      "type": "WMS",
      "wms_params": {
            "url": "http://geoserver.pathway.com.np/geoserver/nepal/wms",
            "source_version": "1.1.1",
            "source_layers": "nepal:district",
            "source_styles": "mep_district",
            "layer": "district"
      }
   },
   {
      "id": "gaunagar",
      "title": "Municipality Boundary",
      "visible": true,
      "type": "WMS",
      "wms_params": {
            "url": "http://geoserver.pathway.com.np/geoserver/nepal/wms",
            "source_version": "1.1.1",
            "source_layers": "nepal:gapanapa",
            "source_styles": "mep_gapanapa",
            "layer": "gaunagar"
      }
   },
   {
      "id":"shs",
      "sub_group":null,
      "title":"Plan Municipalities",
      "visible":true,
      "enabled":true,
      "source":"MEP",
      "description":"Plan Municipalities",
      "legend_path":"/static/icons/cluster/shs.svg",
      "order":1,
      "type":"Vector",
      "vector_params": {
         "id":2,
         "layer":"shs",
         "url": `${process.env.VUE_APP_API_BASE_URL}api/plan/geojson`,
         "style":{
            "geom": "Polygon",
            "fill":"rgb(255,182,9)",
            "stroke":"rgba(255,182,9,0.5)",
         },
      },
   }
];

export default {
   name: 'admin-map',
   data() {
      return {
         map: null,
      };
   },
   components: {
      BaseLayerSelector,
   },
   mounted() {
      const baseLayers = [
         new TileLayer({id: 'OSM',source: new OSM(), visible: false, zIndex: -10 }),
         new TileLayer({id: "BING", visible: false, zIndex: -10,
            source: new BingMaps({
               key: process.env.VUE_APP_BING_API_KEY,
               imagerySet: 'AerialWithLabels',
               maxZoom: 19,
            }),
         }),
      ];
      const adminLayers = adminLayerInfos.map(makeLayer);
      this.map = new Map({
         target: 'admin-map',
         layers: [...baseLayers, ...adminLayers],
         controls: getControls(),
         view: new View({ center: [84, 28.3], zoom: 7.5, projection: 'EPSG:4326', duration: 250 }),
      });
   },
   methods: {
      getMap() {
         return this.map;
      }
   }
}
</script>

<style lang="scss">
#admin-map {
   position: relative;
   width: 100%;
   height: 100%;
   overflow: hidden;
}
#admin-map {
   .ol-zoom.ol-unselectable.ol-control {
      top: 0.4em;
   }
   .ol-zoom-extent.ol-unselectable.ol-control {
      top: 3.5em;
   }
}
</style>
